import { getUserToken } from "@faire/help-center-utils/serialized-data/getUser";
import { trackHelpCenterEmailClick } from "@faire/web-api--source/events/helpCenter/click/email";

export const trackEmailUsClickWhenChatInBusinessHours = (
  issueType: string,
  doNotTrack: boolean
) => {
  if (doNotTrack) {
    return;
  }
  const userToken = getUserToken() ?? "";
  trackHelpCenterEmailClick(userToken, userToken, issueType);
};
